import type { IconSize } from '@proton/icons/types';

const VpnProLogo = ({ size }: { size: IconSize }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            // eslint-disable-next-line jsx-a11y/prefer-tag-over-role
            role="img"
            className={`icon-size-${size}`}
        >
            <path
                d="M11.1506 20.1604L12.0234 18.8586L18.6533 8.8438C19.233 7.9682 18.6797 6.7936 17.6309 6.67319L1.17725 4.78418L9.7007 20.1073C10.0118 20.6557 10.7983 20.6858 11.1506 20.1604Z"
                fill="url(#paint0_linear_32_5752)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.92222 20.2115L10.8188 21.8291C11.7478 23.4993 14.1335 23.5897 15.1882 21.9948L25.0231 7.12332C26.066 5.54625 25.0682 3.43183 23.1795 3.21694L3.84888 1.01746C1.78795 0.782968 0.320554 2.95609 1.32297 4.75818L1.40159 4.89878L5.7 12.6113L9.92222 20.2115ZM2.19687 4.27207L2.27509 4.41195L6.57416 12.1257L11.6927 21.343L11.6932 21.3441C12.2575 22.3567 13.7127 22.4131 14.3541 21.4432L24.189 6.57171C24.814 5.62661 24.2243 4.34227 23.0664 4.21053L3.73583 2.01105C2.46719 1.86671 1.59896 3.19569 2.19687 4.27207Z"
                fill="#6D4AFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.92222 20.2115L10.8188 21.8291C11.7478 23.4993 14.1335 23.5897 15.1882 21.9948L25.0231 7.12332C26.066 5.54625 25.0682 3.43183 23.1795 3.21694L3.84888 1.01746C1.78795 0.782968 0.320554 2.95609 1.32297 4.75818L1.40159 4.89878L5.7 12.6113L9.92222 20.2115ZM2.19687 4.27207L2.27509 4.41195L6.57416 12.1257L11.6927 21.343L11.6932 21.3441C12.2575 22.3567 13.7127 22.4131 14.3541 21.4432L24.189 6.57171C24.814 5.62661 24.2243 4.34227 23.0664 4.21053L3.73583 2.01105C2.46719 1.86671 1.59896 3.19569 2.19687 4.27207Z"
                fill="url(#paint1_linear_32_5752)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.92276 20.2182C10.2338 20.7666 11.0204 20.7968 11.3726 20.2714L12.2455 18.9695L18.8754 8.95473C19.455 8.07913 18.9018 6.90453 17.853 6.78412L1.39931 4.89511L9.92276 20.2182ZM3.21976 6.11068L10.6759 19.5149L11.4149 18.4127L18.0415 8.40272C18.2031 8.15868 18.0572 7.81414 17.7389 7.77759L3.21976 6.11068Z"
                fill="#6D4AFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.92276 20.2182C10.2338 20.7666 11.0204 20.7968 11.3726 20.2714L12.2455 18.9695L18.8754 8.95473C19.455 8.07913 18.9018 6.90453 17.853 6.78412L1.39931 4.89511L9.92276 20.2182ZM3.21976 6.11068L10.6759 19.5149L11.4149 18.4127L18.0415 8.40272C18.2031 8.15868 18.0572 7.81414 17.7389 7.77759L3.21976 6.11068Z"
                fill="url(#paint2_linear_32_5752)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_32_5752"
                    x1="15.5002"
                    y1="21"
                    x2="1.59367"
                    y2="-2.84611"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0660125" stopColor="#8EFFEE" />
                    <stop offset="0.4499" stopColor="#C9C7FF" />
                    <stop offset="1" stopColor="#7341FF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_32_5752"
                    x1="10.8379"
                    y1="-0.972855"
                    x2="12.3806"
                    y2="23.3725"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.172059" stopColor="#24ECC6" stopOpacity="0" />
                    <stop offset="1" stopColor="#24ECC6" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_32_5752"
                    x1="10.8379"
                    y1="-0.972855"
                    x2="12.3806"
                    y2="23.3725"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.172059" stopColor="#24ECC6" stopOpacity="0" />
                    <stop offset="1" stopColor="#24ECC6" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default VpnProLogo;
